module.exports = __webpack_public_path__ + "application/templates/default/partials/menu-bar.template.html";